

















import { computed, defineComponent, PropType } from '@vue/composition-api';
import { convertSurveyIdToUrl } from '@front-app/util/content';
import { HighlightsSurveyMeta } from '@front-app/modules/group/highlights/model';

export default defineComponent({
	props: {
		meta: {
			type: Object as PropType<HighlightsSurveyMeta>,
			required: true,
		},
	},
	setup(props) {
		const surveySrc = computed(() => {
			// Use a provided source URL or construct one from id and survey provider type
			if (props.meta.src) {
				return props.meta.src;
			}
			return convertSurveyIdToUrl(props.meta.surveyId, props.meta.type);
		});

		return { surveySrc };
	},
});
